module.exports = __webpack_public_path__ + "img/arrow_right.5e3d7691.svg";